import { useLocalizeProperty } from '@mews/framework';
import { useProductsByServiceType } from '../../productCheckList/components/panels/ProductCheckListFilterFields/utils/useProductsByServiceType';

export const useGetAdditionalServiceName = (serviceId: string) => {
    const localizeProperty = useLocalizeProperty();
    const { productsByServiceType } = useProductsByServiceType();

    if (!productsByServiceType?.Additional) return undefined;

    const additionalService = productsByServiceType.Additional.map((item) => item.service).find((service) =>
        service.id.includes(serviceId)
    );

    return localizeProperty(additionalService?.names);
};
